module.exports = __webpack_public_path__ + "images/interview-laptop-technical.webp";